import React from 'react'
import { useLocation } from '@fs/zion-router'
import { baseUrl, targetEnv } from '@fs/zion-config'
import StructuredData from './StructuredData'

const getEnvServer = () => {
  if (targetEnv === 'local') return 'http://localhost:5001'
  return baseUrl
}

const getListItemData = (url) => {
  let currentPath = `${baseUrl}/rootstech`
  const envServer = getEnvServer()
  const segments = url.replace(envServer, '').split('/').filter(Boolean)
  const itemList = [
    {
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: currentPath,
    },
  ]

  segments.forEach((segment, index) => {
    currentPath += `/${segment}`
    itemList.push({
      '@type': 'ListItem',
      position: index + 2,
      name: decodeURIComponent(segment)
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase()),
      item: currentPath,
    })
  })

  return itemList
}

function getBreadcrumbListData(url) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: getListItemData(url),
  }
}

export default function BreadcrumbListStructuredData() {
  const location = useLocation()
  if (!location) return null
  const structuredData = getBreadcrumbListData(location.pathname)
  return <StructuredData data={structuredData} dataTestId="breadcrumb-list-structured-data" />
}
